import apix from './api.js'
import store from './store/index.js'
import ixr from '@/components/navigation/ixrouter.js'
import urls from '@/data/urls.js'

let botTest = new RegExp('bot|crawler|spider|crawling|facebook|twitter|lighthouse', 'ig')

export default {
  imagebase: urls.imagebase,
  breakpoints: [
    { name: 'wide', minWidth: 1300, columns: 5},
    { name: 'standard', minWidth: 1100, columns: 4},
    { name: 'ipad landscape', minWidth: 1024, columns: 4},
    { name: 'ipad tall', minWidth: 640, columns: 3},
    { name: 'mobile', minWidth: 200, columns: 2}
  ],
  isBot() {
    if(navigator) {
      return botTest.test(navigator.userAgent)
    }
    return false
  },
  clippableExtensions: ['ytv', 'mov','mp4','flv'],
  linkifyText: function (element) {
    let all = element.querySelectorAll('a')
    if(all) {
      let arr = Array.from(all)
      for(let link of arr) {
        if(link.attributes['href']){
          let href = '' + link.attributes['href'].value
          if(href) {
            if((!href.startsWith('http')) && (!href.startsWith('mailto'))){
              link.addEventListener('click', (e) => {
                if(e) {
                  e.preventDefault()
                }
                ixr.push(href)
              })
            }
          }
        }
      }
    }
  },
  randomBlurry() {
    let randomIndex = Math.floor(Math.random() * 3) + 1;
    return this.imagebase + 'mediastore/img/blurry/blurry' + randomIndex + '.jpg'
  },
  shuffleCopyArray: function (arr) {
    let array = arr.concat()
    var currentIndex = array.length;
    var temporaryValue, randomIndex;
    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
    return array;
  },
  forceFileExtension(timage, ext) {
    if(!timage.endsWith(ext)) {
      let timages = timage.split('.')
      timages.pop()
      timage = timages.join('.') + ext
    }
    return timage
  },
  shufffleCopyObjectArray: function (arr) {
    let array = arr.slice(0)
    for(var each of array) {
      each.rnd = Math.random() * 100
    }
    return array.sort((el, el1) => { return el.rnd - el1.rnd })
  },
  validEmail: function(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email)
  },
  getBreakpoint() {
    return this.breakpoints.find(el => el.minWidth < window.innerWidth)
  },
  getPortfolioLink(artist) {
    if(artist.illustrator) {
      return '/artists/' + artist.portfolio_url
    }
    else {
      return '/animators/' + artist.portfolio_url
    }
  },
  getImageCrop320: function (rel) {
    if(!rel) return ''
    let strs = rel.split('/')
    let imagename = strs.pop()
    return this.imagebase + strs.join('/') + '/crop/320/' + imagename
  },
  getImageCrop500: function (rel) {
    if(!rel) return ''
    let strs = rel.split('/')
    let imagename = strs.pop()
    return this.imagebase + strs.join('/') + '/crop/500/' + imagename
  },
  getImagePermalink: function (image, artist) {
    let strs = image.url.split('/')
    if(image.animation && artist.animation) {
      return '/animators/' + strs[2] + '/' + strs[3]
    }
    return '/artists/' + strs[2] + '/' + strs[3]
  },
  getZoomImage: function (rel) {
    if(!rel) return ''
    let strs = rel.split('/')
    let imagename = strs.pop()
    return this.imagebase + strs.join('/') + '/watermark/1300/' + imagename
  },
  getImage320: function (rel) {
    if(!rel) return ''
    let strs = rel.split('/')
    let imagename = strs.pop()
    return this.imagebase + strs.join('/') + '/full/320/' + imagename
  },
  getImage500: function (rel) {
    if(!rel) return ''
    let strs = rel.split('/')
    let imagename = strs.pop()
    return this.imagebase + strs.join('/') + '/full/500/' + imagename
  },
  getArtistPortraitUrl: function (portfolioname) {
    return this.imagebase + 'images/artist/' + portfolioname + '/profile/crop/320/' + portfolioname + '.jpg'
  },
  loadImage: async function (url) {
    return new Promise((resolve, reject) => {
      let loaded = false
      let im = new Image()
      im.onload = function () {
        loaded = true
        resolve(im)
      }
      im.src = url
      if(im.complete) {
        loaded = true
        resolve(im)
      }
      setTimeout(() => {
        if(!loaded) {
          reject('timeout loading image' + url)
        }
      }, 8000)
    })
  },
  sendGaEvent(category, action, label) {
    if(store.state.lang !== 'CN'){
      if(window.gtag) {
        console.log('sending gtag event', { category: category, action: action, label: label})
        window.gtag('event', action, {
          'event_category': category,
          'event_label': label
        });
      }
      
    }
    if(category === 'ArtistQuote') {
      if(window.fbq){
        window.fbq('track', 'Lead', {
            value: 20,
            currency: 'USD',
        });
      }
    }
  },
  sendAgentCallEvent(name) {
    this.sendGaEvent('Agent Call Tacking', 'CallClick', name )
  },
  sendAgentEmailEvent(name) {
    this.sendGaEvent('AgentEmail', 'Click', name)
    if(window.fbq) {
      window.fbq('track', 'Lead')
    }
  },
  sendSocialEvent(name) {
    this.sendGaEvent('Social', 'Click', name)
  },
  urlExists: async function (url) {
    let retval = true
    try {
      console.log('testing url', url)
      let res = await apix.head(url)
      console.log('url ' + url, res.status)
      retval =  (res.status === 200)
    }
    catch(err) {
      console.log(url + ' got error')
      retval = false
    }
    return retval
  },
  cleanGalleryName: function (gname) {
    let ret = gname.replace(/->/g, '')
    ret = ret.replace(/>/g, '')
    ret = ret.replace(/-%3e/g, '')
    return ret
  },
  waitfor: async function (len) {
    return new Promise((resolve, reject) => {
      try {
        setTimeout(() => {
          resolve()
        }, len)
      }
      catch(err) {
        reject(err)
      }
    })
  },
  isAnimationRoute(path) {
    if(!path) return false
    return (path.indexOf('animat') >= 0)
  },
  tagToUrl: function (tag) {
    if(!tag) return ''
    let ret = tag.replace(/ /g, '-').toLowerCase()
    return ret
  },
  getExtension: function (url) {
    try {
      if(!url) return ''
      return url.split('.').pop().toLowerCase()
    }
    catch(err) {
      console.log('problem is url is',url)
    }
    return ''
  },
  canHaveClip: function (url) {
    let ext = this.getExtension(url)
    return this.clippableExtensions.includes(ext)
  },
  getVideoUrl: function (image, artist) {
    let ext = this.getExtension(image.swf)
    if((ext === 'mov')||(ext === 'flv')){
      this.url = `media/artist/${artist.portfolio_url}/${image.swf}.mp4`
    }
    else {
      this.url = `media/artist/${artist.portfolio_url}/${image.swf}`
    }
  },
  getPreviewClipUrl: function (image, artist) {
    let ext = this.getExtension(image.swf)
    if(this.canHaveClip(image.swf))
    {
      if(ext === 'mov' || ext === 'flv'){
        return `${this.imagebase}media/artist/${artist.portfolio_url}/${image.swf}.mp4.clip.mp4`
      }
      else {
        return `${this.imagebase}media/artist/${artist.portfolio_url}/${image.swf}.clip.mp4`
      }
    }
    return ''
    
  },
  loadStories: async function (page, lang) {
    try {
      let res = await apix.post('stories/get', { page: page, lang: lang })
      return res.data
    }
    catch(err) {
      console.log(err)
    }
  },
  saveStory: async function (page, item, text) {
    try {
      let i = `${store.state.lang}#${item}`
      let res = await apix.post('stories/put', { page: page, lang: i, text: text},
      { headers: {'Authorization': store.state.adminToken } })
      console.log(res.data)
      this.putStoryLocal(page, i, text)
    }
    catch(err) {
      console.log(err)
    }
  },
  uploadFile: async function (info) { // simply appends the file url to the story after pipe |
    try {
      let res = await apix.post('files/put', info,
        { headers: {'Authorization': store.state.adminToken } })
      return res.data
    }
    catch(err) {
      console.log(err)
      return { status: 'fail', message: 'file upload error: ' + err.message }
    }
  },
  containsTags: function (s) {
    if (!s) return false;
    try {
      var ret = s.match(/[<>]/);
      return ret;
    }
    catch(err) {
      console.log('Problem matching ', JSON.stringify(s))
      console.log(err)
    }
    return false
  },
  checkObjectForTags: function (obj) {
    for(let each of Object.keys(obj)){
      if(this.containsTags(obj[each])){
        return true
      }
    }
    return false
  },
  putStoryLocal: function (page, item, story) {
    if(!localStorage[`stories-${page}-${store.state.lang}`]) {
      localStorage[`stories-${page}-${store.state.lang}`] = JSON.stringify({})
    }
    let lstories = JSON.parse(localStorage[`stories-${page}-${store.state.lang}`])
    lstories[item] = story
    localStorage[`stories-${page}-${store.state.lang}`] = JSON.stringify(lstories)
  },
  putStoriesLocal: function (page, storiesArray) {
    // expires in 30 minutes
    let info = { expires: Date.now() + 1800000 }
    for(let story of storiesArray) {
      info[story.item] = story.text
    }
    if(!localStorage[`stories-${page}-${store.state.lang}`]) {
      localStorage[`stories-${page}-${store.state.lang}`] = JSON.stringify({})
    }
    localStorage[`stories-${page}-${store.state.lang}`] = JSON.stringify(info)
  },
  getStoryLocal: function (page, item) {
    item = `${store.state.lang}#${item}`
    let stories = this.getStoriesLocal(page)
    if(stories === null) {
      console.log('getStoriesLocal is returning null')
      return null
    }
    return stories[item]
  },
  getStoriesLocal: function (page) {
    if(!page) throw('page is null')
    const key = `stories-${page}-${store.state.lang}`
    if(localStorage[key]) {
      return JSON.parse(localStorage[key])
    }
    else {
      console.log(`unable to find ${key}`)
    }
    return null
  },
  messageBox: function (title, message) {
    store.commit('setMessage', { title: title, message: message, show: true})
  },
  fetchStories: function (page, callback) {
    let res = this.getStoriesLocal(page)
    if(res) {
      callback(res)
      if(res.expires < Date.now())
      {
        //console.log('fetching stories because expired: ' + res.expires + ' < ' + Date.now() )
        this.forceFetchStories(page, callback)
      }
    }
    else {
      //console.log('fetching stories because no local found')
      this.forceFetchStories(page, callback)
    }
  },
  forceFetchStories: async function(page, callback){
    let remote = await this.loadStories(page, store.state.lang)
    if(remote) {
      this.putStoriesLocal(page, remote)
      if(callback) {
        callback(this.getStoriesLocal(page))
      }
    }
  },
  spacesAfterCommas: function (str) {
    if(!str) return ''
    let arr = str.split(',')
    return arr.join(', ')
  },
  setMetatags: function (title, description, richSnippet) {
    if(document) {
      document.title = title
      let mtag = document.querySelector('#dmtag')
      if(mtag) {
        mtag.content = description
      }
      let rs = document.querySelector('#rsnippet')
      if(rs) {
        rs.remove()
      }
      if(richSnippet) {
        let s = document.createElement('script')
        s.setAttribute('id', 'rsnippet')
        s.setAttribute('type', 'application/ld+json')
        s.innerHTML = JSON.stringify(richSnippet, null, 2)
        document.querySelector('head').append(s)
      }
    }
  },
  setMeta(name, value) {
    this.removeMeta(name)
    let s = document.createElement('meta')
    s.setAttribute('property', name)
    s.setAttribute('content', value)
    document.querySelector('head').append(s)
  },
  removeMeta(name) {
    let rs = document.querySelector(`meta[property="${name}"]`);
    if(rs){
      rs.remove()
    }
  },
  setTwitterMetas(desc, imageUrl, video, url, desc2) {
    this.setMeta('fb:app_id', '426375931294722')
    this.setMeta('og:type', 'article')
    this.setMeta('og:url', url)
    if(video) {
      this.setMeta('og:video', imageUrl)
      this.removeMeta('og:image')
    }
    else {
      this.removeMeta('og:video')
      if(imageUrl) {
        this.setMeta('og:image', imageUrl)
      }
      else {
        this.removeMeta('og:image')
      }
    }
    this.setMeta('og:title', desc)
    this.setMeta('og:description', desc2)
  },
  removeTwitterAndOgs(){
    this.removeMeta('og:title')
    this.removeMeta('og:video')
    this.removeMeta('og:image')
    this.removeMeta('og:url')
    this.removeMeta('og:description')
  },
  getSiteFromNavigator(lang) {
    if((lang == 'en-US') || (lang === 'en-CA')) {
      return 'US'
    }
    else if(lang === 'en-AU') {
      return 'AU'
    }
    else if(lang === 'en-IN'){
      return 'IN'
    }
    else if(lang.startsWith('fr')){
      return 'FR'
    }
    else if(lang.startsWith('de')) {
      return 'DE'
    }
    else if(lang.startsWith('sg')) {
      return 'SG'
    }
    else if(lang === 'pt-BR') {
      return 'BR'
    }
    else if(lang === 'es-AR') {
      return 'SX'
    }
    else if(lang.startsWith('zh')) {
      return 'CN'
    }
  },
  prevkey: 'ArrowLeft',
  nextkey: 'ArrowRight'
}